











import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import Header from '../components/Header.vue';

export default Vue.extend({
    name: 'StaticPage',
    props: ['text'],
    components: {
        Header,
        VueMarkdown,
    },
});
